/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSyncEntitiesByDisplayDate} from '../api'

 export const useQueryGetSyncEntitiesByDisplayDate = createReactQueryHook('getSyncEntitiesByDisplayDate', getSyncEntitiesByDisplayDate)
